import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#FF4C00",
      dark: "#cc3d00",
      light: "#ff704d",
      contrastText: "#fff",
    },
    text: {
      primary: "#2D2D2D",
      secondary: "#757575",
    },
    grey: {
      100: "#f5f5f5",
      400: "#B8B8B8",
      800: "#404040",
      900: "#2D2D2D",
    },
    divider: "#e0e0e0",
    background: {
      default: "#ffffff",
      paper: "#ffffff",
    },
  },
  // Add other theme customizations as needed
});

export default theme;
